import "./statics/css/tailwind.output.css";

import React, { useEffect, useState } from "react";

import AuthenticatedPage from "./pages/Authenticated";
import PublicPage from "./pages/Public";
import useCurrentUser from "./hooks/useCurrentUser";

const App = () => {
  const currentUser = useCurrentUser();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {isLoading && !currentUser ? (
        <></>
      ) : !currentUser ? (
        <PublicPage />
      ) : (
        <AuthenticatedPage />
      )}
    </div>
  );
};

export default App;
